module.exports = __webpack_public_path__ + "img/hr-wooden-particle-08.7f74dbfc.png";